import { Button } from '@deckee/deck-hand';
import PropTypes from 'prop-types';
import React from 'react';

const SubmitShare = (props) => {
  const { action, disabled, submitting, label } = props;

  return (
    <Button
      wide
      onClick={action && (() => action())}
      onKeyDown={action && (() => action())}
      type="submit"
      disabled={disabled}
    >
      {submitting ? 'Submitting...' : label}
    </Button>
  );
};

SubmitShare.propTypes = {
  /** Action for the onClick event */
  action: PropTypes.func,

  /** Changes button label when button in the process of submitting */
  submitting: PropTypes.bool,

  /** Is the button currently disabled */
  disabled: PropTypes.bool,

  /** The text label for the submit button */
  label: PropTypes.string,

  iconName: PropTypes.oneOf([undefined, 'send', 'share']),

  /** Extra classes */
  className: PropTypes.string,
};

SubmitShare.defaultProps = {
  action: undefined,
  submitting: false,
  disabled: false,
  label: 'Continue',
  iconName: undefined,
  className: null,
};

export default SubmitShare;
